/* eslint-disable no-param-reassign */
export const HEAD = {
  width: 400,
  height: 600,
};

export const HEAD_CUT = {
  width: 800,
  height: 600,
};

export const SCALE_HEAD_CUT = 0.6;

export const canvasToImage = (canvas) => canvas.toDataURL("image/png", 1.0);

export const canvasToBlob = (canvas) =>
  new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    });
  });

export const initCanvas = ({ width, height }) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  return [canvas, context];
};

// This function fix Safari issue with standard drawImage canvas method
export const drawImage = (ctx, image, sx, sy, sw, sh, dx, dy, dw, dh) => {
  if (sx < 0) {
    sx = 0;
  }

  if (sy < 0) {
    sy = 0;
  }

  if (sx + sw > image.width) {
    sw = image.width - sx;
  }

  if (sy + sh > image.height) {
    sh = image.height - sy;
  }

  ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
};

export const matrixFor = ({ rotation, center }) => {
  const [, context] = initCanvas({ width: 1, height: 1 });
  context.translate(center.x, center.y);
  context.rotate(-rotation);
  context.translate(-center.x, -center.y);
  return context.getTransform();
};

export const drawHead = (ctx, sourceImage, headObject) => {
  const { container, rotation, faceMidPoint } = headObject;
  const [image, imageCtx] = initCanvas(sourceImage);
  imageCtx.translate(faceMidPoint.x, faceMidPoint.y);
  imageCtx.rotate(-rotation);
  imageCtx.translate(-faceMidPoint.x, -faceMidPoint.y);
  imageCtx.drawImage(sourceImage, 0, 0);
  drawImage(ctx, image, container.x, container.y, container.width, container.height, 0, 0, HEAD.width, HEAD.height);
};

export const drawHeadMask = (ctx, mask) => {
  ctx.globalCompositeOperation = "destination-in";
  ctx.drawImage(mask, 0, 0);
};

export const drawHeadCut = (ctx, image, headObject, scale) => {
  const { container, rotation, faceMidPoint } = headObject;
  const [imageCnv, imageCtx] = initCanvas(image);

  imageCtx.translate(faceMidPoint.x, faceMidPoint.y);
  imageCtx.rotate(-rotation);
  imageCtx.scale(scale, scale);
  imageCtx.translate(-faceMidPoint.x, -faceMidPoint.y);

  imageCtx.drawImage(image, 0, 0);

  drawImage(
    ctx,
    imageCnv,
    container.x,
    container.y,
    container.width,
    container.height,
    HEAD.width / 2,
    0,
    HEAD.width,
    HEAD.height,
  );
};

export const drawHeadCutMask = (mask, scale = 1) => {
  const [cnv, ctx] = initCanvas(HEAD_CUT);

  ctx.translate(HEAD_CUT.width / 2, HEAD_CUT.height / 2);
  ctx.scale(scale, scale);
  ctx.translate(-HEAD_CUT.width / 2, -HEAD_CUT.height / 2);
  ctx.drawImage(mask, 0, 0);
  return cnv;
};

export const getHeadFromHeadCut = (headCut, mask, transforms) => {
  const [headCnv, headCtx] = initCanvas(HEAD_CUT);
  const { offset, rotation, scale } = transforms;
  const reverseScale = 1 / SCALE_HEAD_CUT;
  const [cnv, ctx] = initCanvas(HEAD);

  headCtx.clearRect(0, 0, HEAD_CUT.width, HEAD_CUT.height);
  headCtx.save();

  headCtx.translate(HEAD_CUT.width / 2, HEAD_CUT.height / 2);
  headCtx.rotate(-rotation);
  headCtx.scale(scale, scale);
  headCtx.scale(reverseScale, reverseScale);
  headCtx.translate(-HEAD_CUT.width / 2, -HEAD_CUT.height / 2);
  headCtx.translate(offset.x, offset.y);
  headCtx.drawImage(headCut, 0, 0);
  headCtx.restore();

  headCtx.translate(200, 0);
  headCtx.globalCompositeOperation = "destination-in";
  headCtx.drawImage(mask, 0, 0);

  drawImage(ctx, headCnv, 200, 0, HEAD.width, HEAD.height, 0, 0, HEAD.width, HEAD.height);

  return cnv;
};

const drawSvgCommand = (ctx, command) => {
  const [action, ...args] = command;
  switch (true) {
    case action === "M":
      return ctx.moveTo(...args);
    case action === "L":
      return ctx.lineTo(...args);
    case action === "C":
      return ctx.bezierCurveTo(...args);
    case action === "Q":
      return ctx.quadraticCurveTo(...args);
    default:
      return null;
  }
};

export const drawSvgPath = (ctx, svgPath, { color }) => {
  const { path: commands } = svgPath;
  ctx.strokeStyle = color;
  ctx.beginPath();
  ctx.lineWidth = 4.0;
  commands.map((command) => drawSvgCommand(ctx, command));
  ctx.closePath();
  ctx.stroke();
};
